import { z } from 'zod'

import {
  MarketingChannel,
  MarketingCorporateListSlug,
  MarketingListMembershipStatus,
  MarketingListVisibility,
} from '../constants/marketing'
import { dbEntitySchema } from './system'
import { marketingEntityScopeSchema } from './marketingScope'

export const marketingListSchema = dbEntitySchema
  .and(marketingEntityScopeSchema)
  .and(
    z.object({
      name: z.string(),
      slug: z.string().nullish(),
      channel: z.nativeEnum(MarketingChannel),
      visibility: z.nativeEnum(MarketingListVisibility),
      corporateSlug: z.nativeEnum(MarketingCorporateListSlug).nullish(),
    })
  )

export const marketingListMembershipSchema = dbEntitySchema.extend({
  contact: z.string(),
  list: z.string(),
  status: z.nativeEnum(MarketingListMembershipStatus),
})
